import React from 'react';

const Value = () => {
  const cards = [
    {
      id: 1,
      title: 'Para Colegios',
      description: 'Elevamos la calidad educativa y el prestigio institucional con programas de clase mundial.',
      image: 'salon.png',
    },
    {
      id: 2,
      title: 'Para Estudiantes y Familias',
      description: 'Rutas claras hacia admisiones internacionales y desarrollo de habilidades globales.',
      image: 'estudiante.png', 
    },
    {
      id: 3,
      title: 'Para Aliados Internacionales',
      description: 'Pipeline de talento preparado y procesos bien gobernados.',
      image: 'https://plus.unsplash.com/premium_photo-1683887033741-f7ae791b4831?q=80&w=2338&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // International group placeholder
    }
  ];

  return (
    <section className="bg-whit min-h-[80vh] py-20 px-6 md:px-12 lg:px-16 font-sans">
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="mb-12">
          {/* Badge */}
          <div className="inline-block px-6 py-1.5 border border-gray-400 rounded-full mb-6">
            <span className="text-gray-600 text-sm font-medium">Propuesta de Valor</span>
          </div>
          
          {/* Title */}
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a3b5c] tracking-tight">
            Diseñado para tu  <span className="text-[#5B9BB0]">Éxito.</span>
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card) => (
            <div 
              key={card.id} 
              className="group border border-gray-200 rounded-[2.5rem] p-4 flex flex-col hover:shadow-lg transition-shadow duration-300 bg-white"
            >
              {/* Image Container */}
              <div className="h-[384px] overflow-hidden rounded-[2rem] mb-6">
                <img 
                  src={card.image} 
                  alt={card.title} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="px-2 pb-2 flex-grow flex flex-col">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {card.title}
                </h3>
                
                <p className="text-gray-500 text-sm leading-relaxed mb-8 flex-grow">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Value;